import { Html } from "@custom/schema";
import clsx from "clsx";
import { selectAll } from "hast-util-select";
import React from "react";
import { FadeUp } from "../../Molecules/FadeUp";
export var unorderedItems = function() {
    return function(tree) {
        selectAll("ul > li", tree).forEach(function(node) {
            node.properties.unordered = true;
        });
    };
};
export function BlockMarkup(props) {
    var _props_animationDisabled;
    return /*#__PURE__*/ React.createElement(FadeUp, {
        yGap: 30,
        className: "container-page",
        disabled: (_props_animationDisabled = props.animationDisabled) !== null && _props_animationDisabled !== void 0 ? _props_animationDisabled : false
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-text my-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "prose"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(props.className, "prose-wrapper text-black")
    }, /*#__PURE__*/ React.createElement(Html, {
        plugins: [
            unorderedItems
        ],
        components: {
            blockquote: function(param) {
                var children = param.children;
                return /*#__PURE__*/ React.createElement("div", {
                    className: "not-prose quote-wrapper"
                }, /*#__PURE__*/ React.createElement("blockquote", {
                    className: "border-l-0 relative pl-0 quote-content"
                }, children));
            }
        },
        markup: props.markup
    }))))));
}
